import React from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { getOrgTermsContent } from '../../content/utils.js';

const MyProjectSelect = ({ selectedOwnerIds, onSelectAll, onSelectMine }) => {
  const projectTerm = getOrgTermsContent('project');
  const projectsTermPlural = getOrgTermsContent('projects');

  return (
    <div className="flex">
      <div className="text-muted filter-label text-capitalize m-r-8">
        {projectTerm} Owner
      </div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedOwnerIds.length ? `My ${projectsTermPlural}` : 'All'}
          id="owner-filter"
          className="btn-block"
          style={{ minWidth: '200px' }}
          pullRight
        >
          <MenuItem active={!selectedOwnerIds.length} onSelect={onSelectAll}>
            All
          </MenuItem>
          <MenuItem active={!!selectedOwnerIds.length} onSelect={onSelectMine}>
            {`My ${projectsTermPlural}`}
          </MenuItem>
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
};

export default MyProjectSelect;
